import { SolicitationProps } from "../../../../../domain/models/solicitation.model";
import { StackModel } from "../../../../../domain/models/stacks";

export const fields = (
  data: SolicitationProps | undefined,
  stackList: StackModel[] | undefined
): any[] => [
  {
    groupName: "Login",
    groupLabel: "Dados pessoas:",
    items: [
      {
        name: "name",
        type: "text",
        label: "Nome",
        value: data?.id,
        validations: "inputRequired",
        col: {
          xs: 8,
          md: 8,
          lg: 8,
        },
      },
      {
        name: "cpf",
        type: "text",
        label: "CPF:",
        validations: "inputRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
      {
        name: "email",
        type: "text",
        label: "E-mail:",
        validations: "inputRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
      {
        name: "telefone",
        type: "text",
        label: "Telefone:",
        validations: "inputRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
      {
        name: "stack",
        type: "checkboxGroup",
        label: "Stack:",
        validations: "inputRequired",
        options: stackList?.map((el) => ({
          value: el.id,
          label: el.description,
        })),
        defaultValue: 0,
        col: {
          xs: 8,
          md: 8,
          lg: 8,
        },
      },
    ],
  },
  {
    groupName: "company",
    groupLabel: "Dados CNPJ:",
    items: [
      {
        name: "subscriptionNumber",
        type: "text",
        label: "Razão Social",
        validations: "inputRequired",
        col: {
          xs: 8,
          md: 8,
          lg: 8,
        },
      },
      {
        name: "stateRegistration",
        type: "text",
        label: "CNPJ:",
        mask: "SS.SSS.SSS/SSSS-00",
        validations: "inputRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
      {
        name: "fantasyName",
        type: "text",
        label: "Nome Fantasia",
        validations: "inputRequired",
        col: {
          xs: 8,
          md: 8,
          lg: 8,
        },
      },
      {
        name: "emailCompany",
        type: "text",
        label: "E-mail Cadastrado:",
        validations: "inputRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
    ],
  },
  {
    groupName: "address",
    groupLabel: "Endereço:",
    items: [
      {
        name: "address",
        type: "text",
        label: "Endereço",
        validations: "inputRequired",
        col: {
          xs: 8,
          md: 8,
          lg: 8,
        },
      },
      {
        name: "complement",
        type: "text",
        label: "Complemento:",
        validations: "inputRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
      {
        name: "zipCode",
        type: "text",
        label: "CEP:",
        validations: "inputRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
      {
        name: "city",
        type: "text",
        label: "Cidade:",
        validations: "inputRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
      {
        name: "state",
        type: "text",
        label: "Estado:",
        validations: "inputRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
    ],
  },
  {
    groupName: "plan",
    groupLabel: "Plano:",
    items: [
      {
        name: "planName",
        type: "text",
        label: "Plano Escolhido",
        validations: "inputRequired",
        col: {
          xs: 8,
          md: 8,
          lg: 8,
        },
      },
      {
        name: "status",
        type: "select",
        label: "Status:",
        validations: "objectRequired",
        col: {
          xs: 4,
          md: 4,
          lg: 4,
        },
      },
    ],
  },
  {
    groupName: "email",
    groupLabel: "Acesso do Cliente:",
    items: [
      {
        name: "emailRegister",
        type: "text",
        label: "E-mail de Cadastro:",
        validations: "inputRequired",
        col: {
          xs: 8,
          md: 8,
          lg: 8,
        },
      },
    ],
  },
];
